import Index from './pages/index/index';
import Introduce from './pages/introduce/index';
import Qry from './pages/qry/index';
import About from './pages/aboutus/index';
import Tip from './pages/tip/index';
export const routes = [
    {
        path: '/',
        name: 'index',
        intro: '首页',
        component: Index
    }, {
        path: '/introduce',
        name: 'introduce',
        intro: '产品介绍',
        component: Introduce
    }, {
        path: '/about',
        name: 'about',
        intro: '关于我们',
        component: About
    }, {
        path: '/qry',
        name: 'qry',
        intro: '快递查询',
        component: Qry
    }, {
        path: '/tip',
        name: 'tip',
        intro: '合作声明',
        hidden: true,
        component: Tip
    }
];